import Game from './game';

const DROP_SPEED = 2;

const DROPPING_STATE = 'dropping';

const COLLECTING_STATE = 'collecting';

const COLLECTED_STATE = 'collected';

const INSIDE_STATE = 'inside';

const GOING_LEFT_STATE = 'going_left';

const GOING_RIGHT_STATE = 'going_right';

const MISSED_STATE = 'missed';

const CORRECT_ANIMATION_DURATION = 500;

const INCORRECT_ANIMATION_DURATION = 500;

const SPLASH_ANIMATION_DURATION = 500;

const SUITCASE_FROZEN_DURATION = 4000;

const CLOCK_ID = 6;

const ICE_ID = 7;

const PAINT_ID = 8;

const badCollectSound = 'BadCollectSound';
const goodCollectSound = 'GoodCollectSound';
const penaltyFreezeSound = 'PenaltyFreezeSound';
const penaltySplatSound = 'PenaltySplatSound';

createjs.Sound.registerSound('sounds/bad_collect.mp3', badCollectSound);
createjs.Sound.registerSound('sounds/good_collect.mp3', goodCollectSound);
createjs.Sound.registerSound('sounds/penalty_freeze.mp3', penaltyFreezeSound);
createjs.Sound.registerSound('sounds/penalty_splat.mp3', penaltySplatSound);

export default class Item {
    // Collectible or not.
    #type;

    // Id of the element.
    #id;

    // The type id of the item.
    #itemId;

    #currentSpeed;

    #inSuitcaseSpeed;

    #outSuitcaseSpeed;

    // Current x position relative to the game container.
    #currentX;

    // Current y position relative to the game container.
    #currentY;

    // Current height of the element.
    #currentHeight;

    // Current width of the element.
    #currentWidth;

    // Current state of the item.
    #currentState;

    #isCollected;

    #animationShown;

    #soundPlayed;

    constructor(type, id, itemId, speed) {
        this.#type = type;
        this.#id = id;
        this.#itemId = itemId;
        this.#currentState = DROPPING_STATE;
        this.#currentHeight = $(this.#id).height();
        this.#currentWidth = $(this.#id).width();
        this.#animationShown = false;
        this.#isCollected = false;
        this.#soundPlayed = false;
        this.#currentY = 0;
        this.#currentX = Game.getRandomArbitrary(
            0,
            Game.gameWidth - this.#currentWidth
        );

        // Setting speed of items dynamically so it's available for mobile;
        let wrapperHeight = document.querySelector('.wrapper').clientHeight;
        let droppingSpeed = wrapperHeight * 0.0013333333333333333;
        let droppingInSuitcaseSpeed = wrapperHeight * 0.0024000000000000002;
        let droppingOutSpeed = wrapperHeight * 0.0031999999999999995;

        this.#currentSpeed = droppingSpeed * speed;
        this.#inSuitcaseSpeed = droppingInSuitcaseSpeed * speed;
        this.#outSuitcaseSpeed = droppingOutSpeed * speed;

        $(this.#id).css('left', this.#currentX);

        this.startDropping();
    }

    startDropping() {
        if (Game.windowFocused) {
            if (Game.levelIsRunning) {
                // Set collision state.
                this.detectCollision();

                if (
                    this.#currentState === COLLECTING_STATE ||
                    this.#currentState === COLLECTED_STATE
                ) {
                    if (!this.#isCollected) {
                        this.#isCollected = true;
                        if (
                            this.#itemId !== ICE_ID &&
                            this.#itemId !== PAINT_ID
                        ) {
                            // if item is clock prevent adding it to current collected items and update timer bar;
                            if (Game.checkClock(this.#itemId)) {
                                Game.timer.updateTimer(true);
                            } else {
                                Game.currentCollected.push(this.#itemId);
                            }

                            // Show the animation.
                            if (Game.isTheRightItem(this.#itemId)) {
                                ga('send', 'event', {
                                    eventCategory: 'Right Order',
                                    eventAction: 'Games',
                                    eventLabel: 'Alvin and the Chipmunks',
                                });
                                this.showCorrectAnimation();
                                if (!this.#soundPlayed) {
                                    this.#soundPlayed = true;
                                    createjs.Sound.play(goodCollectSound);
                                }
                                if (Game.isTheItemsOrderDone()) {
                                    Game.currentCollectedRounds++;
                                    Game.currentCollected = [];
                                    if (Game.isTheLevelDone()) {
                                        Game.showEndLevelScreen();
                                    } else {
                                        Game.generateLevelItems();
                                    }
                                    // Remove the item and end function.
                                    $(this.#id).remove();
                                    return;
                                }
                            } else {
                                ga('send', 'event', {
                                    eventCategory: 'Wrong Order',
                                    eventAction: 'Games',
                                    eventLabel: 'Alvin and the Chipmunks',
                                });
                                this.showIncorrectAnimation();
                                if (!this.#soundPlayed) {
                                    this.#soundPlayed = true;
                                    createjs.Sound.play(badCollectSound);
                                }
                                // If the item is not right, reset the current collected items array.
                                Game.currentCollected = [];
                            }
                            // if clock item collected, then prevent refreshing collected items and update timer bar;
                            if (this.#itemId !== CLOCK_ID) {
                                Game.refreshCollectedItems();
                            } else {
                                Game.timer.updateTimer();
                            }
                        } else if (this.#itemId === ICE_ID) {
                            Game.suitcaseFrozen = true;
                            $('.game .suitcase').addClass('suitcase-frozen');
                            // Play the sound.
                            createjs.Sound.play(penaltyFreezeSound);
                            setTimeout(() => {
                                Game.suitcaseFrozen = false;
                                $('.game .suitcase').removeClass(
                                    'suitcase-frozen'
                                );
                            }, SUITCASE_FROZEN_DURATION);
                        } else if (this.#itemId === PAINT_ID) {
                            // Show the animation.
                            this.showSplashAnimation();
                            // Play the sound.
                            createjs.Sound.play(penaltySplatSound);
                            // Show the bad luck screen.
                            setTimeout(() => {
                                if (Game.currentScore > Game.highScore) {
                                    Game.showHighScoreScreen();
                                    window.localStorage.setItem(
                                        'high_score',
                                        Game.currentScore
                                    );
                                } else {
                                    Game.showBadLuckScreen();
                                }
                            }, 750);
                        }
                    }
                    // Increase speed.
                    this.#currentSpeed = this.#inSuitcaseSpeed;
                    // "Stick" the item to the suitcase while it goes inside.
                    $(this.#id).css(
                        'left',
                        parseInt($('.game .suitcase').css('left')) +
                            Game.suitcaseWidth / 2 -
                            this.#currentWidth / 2
                    );

                    if (this.#currentState === COLLECTED_STATE) {
                        this.#currentHeight -= DROP_SPEED * this.#currentSpeed;
                        $(this.#id).css('height', this.#currentHeight);
                    }
                    if (this.#currentHeight <= 0) {
                        this.#currentState = INSIDE_STATE;
                    }
                }

                if (
                    this.#currentState === INSIDE_STATE ||
                    (this.#currentY > Game.gameHeight &&
                        (this.#currentState === MISSED_STATE ||
                            this.#currentState === GOING_LEFT_STATE ||
                            this.#currentState == GOING_RIGHT_STATE))
                ) {
                    // Remove the item and end function.
                    $(this.#id).remove();
                    return;
                }

                if (
                    this.#currentState === MISSED_STATE ||
                    this.#currentState === GOING_LEFT_STATE ||
                    this.#currentState === GOING_RIGHT_STATE
                ) {
                    this.#currentSpeed = this.#outSuitcaseSpeed;
                }

                if (this.#currentState === GOING_LEFT_STATE) {
                    if (!this.#animationShown) {
                        this.#animationShown = true;
                        $(this.#id).addClass('going-left-animation');
                    }
                }
                if (this.#currentState === GOING_RIGHT_STATE) {
                    if (!this.#animationShown) {
                        this.#animationShown = true;
                        $(this.#id).addClass('going-right-animation');
                    }
                }
                this.#currentY += DROP_SPEED * this.#currentSpeed;
                $(this.#id).css('top', this.#currentY);
            } else {
                return;
            }
        }

        requestAnimationFrame(() => this.startDropping());
    }

    detectCollision() {
        const itemRect = $(this.#id)[0].getBoundingClientRect();
        const suitcaseRect = $('.game .suitcase')[0].getBoundingClientRect();
        // If the item is in missed state, ignore further calculations.
        if (this.#currentState === MISSED_STATE) {
            if (itemRect.bottom > suitcaseRect.top + DROP_SPEED) {
                $(this.#id).css('z-index', '98');
            }
            return;
        }
        if (itemRect.bottom < suitcaseRect.top - DROP_SPEED) {
            // If the item is above the hit line (Hit line = +/- the DROP_SPEED).
        } else if (
            itemRect.bottom >= suitcaseRect.top - DROP_SPEED &&
            itemRect.bottom <= suitcaseRect.top + DROP_SPEED
        ) {
            // If the item is on the hit line.
            if (
                itemRect.right < suitcaseRect.left ||
                itemRect.left > suitcaseRect.right
            ) {
                // If it's outside the suitcase hitbox.
                this.#currentState = MISSED_STATE;
            } else {
                if (
                    itemRect.right <
                    suitcaseRect.left + Game.suitcaseWidth / 2
                ) {
                    if (this.#currentState !== GOING_LEFT_STATE) {
                        this.#currentState = GOING_LEFT_STATE;
                    }
                } else if (
                    itemRect.left >
                    suitcaseRect.right - Game.suitcaseWidth / 2
                ) {
                    if (this.#currentState !== GOING_RIGHT_STATE) {
                        this.#currentState = GOING_RIGHT_STATE;
                    }
                } else {
                    if (this.#currentState === DROPPING_STATE) {
                        this.#currentState = COLLECTING_STATE;
                    }
                }
            }
        } else {
            // If the item is under the hit line.
            const frontSuitcaseRect = $(
                '.game .suitcase-front'
            )[0].getBoundingClientRect();
            if (
                itemRect.bottom >= frontSuitcaseRect.top &&
                this.#currentState === COLLECTING_STATE
            ) {
                this.#currentState = COLLECTED_STATE;
            }
            if (this.#currentState === MISSED_STATE) {
            }
        }
    }

    showCorrectAnimation() {
        if (!this.#animationShown) {
            this.#animationShown = true;
            const correctAnimation = $('.game .correct-animation').clone(true);
            $('.game .correct-animation').remove();
            correctAnimation.removeClass('hidden');
            $('.game .suitcase').append(correctAnimation);
            clearTimeout(Game.correctAnimationTimeout);
            Game.correctAnimationTimeout = setTimeout(() => {
                $('.game .correct-animation').addClass('hidden');
            }, CORRECT_ANIMATION_DURATION);
        }
    }

    showIncorrectAnimation() {
        if (!this.#animationShown) {
            this.#animationShown = true;
            const incorrectAnimation = $('.game .incorrect-animation').clone(
                true
            );
            $('.game .incorrect-animation').remove();
            incorrectAnimation.removeClass('hidden');
            $('.game .suitcase').append(incorrectAnimation);
            clearTimeout(Game.incorrectAnimationTimeout);
            Game.incorrectAnimationTimeout = setTimeout(() => {
                $('.game .incorrect-animation').addClass('hidden');
            }, INCORRECT_ANIMATION_DURATION);
        }
    }

    showSplashAnimation() {
        if (!this.#animationShown) {
            this.#animationShown = true;
            const splashAnimation = $('.game .splash-animation').clone(true);
            $('.game .splash-animation').remove();
            splashAnimation.removeClass('hidden');
            $('.game .suitcase').append(splashAnimation);
            clearTimeout(Game.splashAnimationTimeout);
            Game.splashAnimationTimeout = setTimeout(() => {
                $('.game .splash-animation').addClass('hidden');
            }, SPLASH_ANIMATION_DURATION);
        }
    }
}
